<template>
    <div class="container">

        <div class="toolbar shadow-sm">
            <img src="@/assets/icons/MapsIcon.png" />
            <span class="title">{{ $t("admin.maps.available_maps") }}</span>
            <!--<button class="btn btn-primary btn-sm">Map Opening Messages???</button>-->
        </div>

        <div v-if="!maps || maps.length == 0" class="empty-list">{{ $t("admin.maps.no_maps_available") }}</div>
        <div v-if="maps && maps.length > 0" class="maps-list">
            <MapBox v-for="map of maps" v-bind:key="map.id" :map="map" />
        </div>
    </div>
</template>

<script>
import MapService from "@/service/MapService.js";
import MapBox from "./MapBox";

const mapService = new MapService();

export default {
    components: {
        MapBox
    },
    data() {
        return {
            publisher: null,
            maps: null
        }
    },
    methods: {
        loadMaps() {
            if (this.publisher) {
                mapService.loadMapsForPublisher(this.publisher.getId()).then((maps) => {
                    this.maps = maps;
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    },
    mounted() {
        this.$store.subscribe( (mutation) => {
            if (mutation.type == "setCurrentPublisher") {
                this.publisher = mutation.payload;
                this.loadMaps();
            }
        });

        this.publisher = this.$store.state.currentPublisher;
        this.loadMaps();
    }
}
</script>

<style scoped>
.container {
    margin: 0px;
    width: 100%;
    max-width: none;
}

.toolbar {
    background-color: #ffffff;
    margin-bottom: 16px;
    padding: 8px;
    padding-left: 24px;
    text-align: left;
    width: 100%;
}

.toolbar img {
    margin-right: 16px;
    width: 50px;
}

.toolbar .title {
    font-weight: bold;
    font-size: 18px;
    margin-right: 36px;
}

.maps-list {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
    height: 100%;
    overflow: scroll;
    padding-bottom: 100px;
}

.empty-list {
    color: #777777;
    font-size: 36px;
    font-weight: bold;
    margin-top: 64px;
    text-align: center;
}
</style>